import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuditModelListPath } from "../../services/config";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  incLoading: false,
  incSuccess: false,
  incError: false,
  incMessage: null,

  incGetLoading: false,
  incGetSuccess: false,
  incGetError: false,
  incGetMessage: null,
  incGetData: null,
};

const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;

const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchIncentiveData = createAsyncThunk(
  "fetchIncentiveData",
  async (data) => {
    const { userId, outletId } = data;
    return await axios
      .get(`${baseUrl}${getAuditModelListPath(userId, outletId)}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const saveUpdateIncentive = createAsyncThunk(
  "saveUpdateIncentive",
  async (body) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const { path, data } = body;

    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(`${baseUrl}${path}`, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              console.log(
                "You are offline. Please check your internet connection."
              );
            } else {
              console.log("An error occurred. Please try again later.");
            }
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          });
  }
);

const incentiveSlice = createSlice({
  name: "incentive",
  initialState,

  reducers: {
    initIncentiveState: (state) => {
      state.incLoading = false;
      state.incSuccess = false;
      state.incError = false;
      state.incMessage = null;

      state.incGetLoading = false;
      state.incGetSuccess = false;
      state.incGetError = false;
      state.incGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchIncentiveData.pending, (state, action) => {
      state.incGetLoading = true;
      state.incGetSuccess = false;
      state.incGetError = false;
      state.incGetMessage = null;
      state.incGetData = null;
    });
    builder.addCase(fetchIncentiveData.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200) {
        state.incGetLoading = false;
        state.incGetSuccess = true;
        state.incGetError = false;
        state.incGetMessage = action.payload.data.message;
        state.incGetData = action.payload.data.data;
      } else {
        state.incGetLoading = false;
        state.incGetSuccess = false;
        state.incGetError = true;
        state.incGetMessage = action.payload.response.data.message;
        state.incGetData = null;
      }
    });
    builder.addCase(fetchIncentiveData.rejected, (state, action) => {
      state.incGetLoading = false;
      state.incGetSuccess = false;
      state.incGetError = true;
      state.incGetMessage = action.payload.data.message;
      state.incGetData = null;
    });

    // To create branch
    builder.addCase(saveUpdateIncentive.pending, (state, action) => {
      state.incLoading = true;
      state.incSuccess = false;
      state.incError = false;
      state.incMessage = null;
    });
    builder.addCase(saveUpdateIncentive.fulfilled, (state, action) => {
      const status = action.payload.status;
      if (status == 200 || status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.incLoading = false;
          state.incSuccess = true;
          state.incError = false;
          state.incMessage = action.payload.data.message;
        } else {
          state.incLoading = false;
          state.incSuccess = false;
          state.incError = true;
          state.incMessage = action.payload.data.message;
        }
      } else {
        state.incLoading = false;
        state.incSuccess = false;
        state.incError = true;
        state.incMessage = action.payload.response.data.message;
      }
    });
    builder.addCase(saveUpdateIncentive.rejected, (state, action) => {
      state.incLoading = false;
      state.incSuccess = false;
      state.incError = true;
      state.incMessage = action.payload.data.message;
    });
  },
});

export const { initIncentiveState } = incentiveSlice.actions;

export default incentiveSlice.reducer;
